var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permaContainer"},[(_vm.feedback)?_c('em',[_vm._v(_vm._s(_vm.feedback))]):_vm._e(),_vm._v(" "),_c('blogitem',{attrs:{"data":_vm.blog[0]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d00dc4c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/blog/confessionPages/blogPerma.vue
// module id = 615
// module chunks = 0